<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-md-6 col-xl-3"
              classLots="col-12 col-md-6 col-xl-3"
              ref="filters"
            >
              <template slot="after-lot">
                <select-component
                  :class="`col-12 col-md-6 col-xl-3 mt-3`"
                  :dataOptions="activities"
                  :labelSelect="`${$t('common_words.activities')}: `"
                  :initialSelection="dataFilter.activities"
                  @onChange="handleChangeSelected"
                  modelName="activities"
                />
                <select-component
                  :class="`col-12 col-md-6 col-xl-3 mt-3`"
                  :dataOptions="workers"
                  :labelSelect="`${$t('labor.workers')}: `"
                  :initialSelection="dataFilter.workers"
                  @onChange="handleChangeSelected"
                  modelName="workers"
                />
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <card v-if="tableData.length > 0">
          <!-- main table -->
          <br />
          <div>
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
            ></card-header>
            <master-table
              :infoTable="queriedData"
              :columns="tableColumns"
              :showColumnStatus="false"
            >
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="isShow()"
                  @handleView="handleView"
                  :showOperationEdit="false"
                  :canDelete="false"
                  :minWidth="120"
                />
              </template>
            </master-table>
            <card-footer ref="cardfooter" :propPagination="pagination" />
          </div>
          <br />
        </card>
        <div v-if="details" class="col-12 text-center">
          <em
            class="nc-icon nc-stre-up"
            style="font-size: 25px; cursor: pointer"
            @click="handleViewDetails"
            v-tooltip.top-center="$t('common_words.hide_detail')"
          ></em>
        </div>
        <card v-if="details">
          <div class="row">
            <div class="col-12 mt-2">
              <p style="font-size: 17px" class="text-muted">
                {{ $t('labor.worker_detail_info') }}
              </p>
            </div>
            <div class="col-12">
              <div class="table-responsive">
                <table aria-describedby="table-details" class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.farm') }}:</strong>
                        </h6>
                        {{ rowData.farm.name }}
                      </td>
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.code') }} -
                            {{ $t('labor.worker') }}:</strong
                          >
                        </h6>
                        {{ rowData.worker.code }} -
                        {{ rowData.worker.name }}
                      </td>
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.save_date') }}:</strong>
                        </h6>
                        {{ rowData.header_date }}
                      </td>
                      <th>
                        <img
                          v-tooltip.top-center="
                            $t('common_words.geo_location_labor_detail')
                          "
                          style="width: 30px; height: 30px"
                          class="pointer"
                          src="/static/img/iconos/map.svg"
                          alt="Icono de Geolocalización"
                          @click="openMap"
                        />
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <el-dialog
              :title="$t('common_words.samples_map')"
              class="zoom-map el-dialog-img-zoom"
              top="15px"
              width="80%"
              :visible.sync="modals.map"
              :close="closeMap"
            >
              <multiple-map ref="map" :height="800" />
            </el-dialog>
          </div>
          <br />
          <div>
            <card-header
              :propPagination="paginationDetails"
              @searchedQuery="searchedQueryDetails"
            ></card-header>
            <master-table
              :infoTable="queriedDataDetails"
              :columns="tableColumnsDetails"
              :showColumnStatus="false"
            >
            </master-table>
            <card-footer
              :propPagination="paginationDetails"
              ref="cardfooterdetail"
            />
          </div>
        </card>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import configTable from 'src/views/Pages/Dashboard/Work/SmartTrack/report-table.js';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MultipleMap from 'src/views/Pages/Dashboard/Work/SmartTrack/MultipleMap.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    [MultipleMap.name]: MultipleMap,
    LPagination,
  },

  data() {
    return {
      activeName: 'filter',
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      dataFilter: {
        farm: [],
        lot: [],
        activities: [],
        workers: [],
      },
      details: false,
      detailsForm: {},
      fuseSearchDetails: null,
      model: null,
      paginationDetails: {},
      reportType: 0,
      searchQueryDetails: '',
      tableColumns: [],
      tableColumnsDetails: [],
      tableDataDetails: [],
      valueCollapse: null,
      activities: [],
      workers: [],
    };
  },

  computed: {
    ...configTable().SearchDetails,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  mixins: [MixinMasters, MixinMenu, MixinPermissions, MixinArcgisMap],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    handleChangeSelected(data) {
      this.$set(this, data.name, data.selects);
    },
    getSelectAll() {
      this.workers = this.concatAll(this.workers.splice(1));
      this.activities = this.concatAll(this.activities.splice(1));
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleFilter(data) {
      this.dataFilter = { ...this.dataFilter, ...data };
      this.details = false;
      this.getDataSamples();
    },

    getDataSamples() {
      this.showHideLoading(true);
      const data = {
        ...this.dataFilter,
        route: 'agrotrack/report',
      };
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleView(_, row) {
      this.showHideLoading(true);

      this.details = false;
      this.rowData = row;

      const data = 'agrotrack/reportdetails/' + this.rowData.id;
      Axios.getMasters(data)
        .then((response) => {
          this.tableDataDetails = response.data.data;
          this.fuseSearchDetails = new Fuse(this.tableDataDetails, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumnsDetails.map((prop) => {
              return prop.prop;
            }),
          });
          this.details = true;
          this.paginationDetails.perPage = 5;
          this.paginationDetails.currentPage = 1;

          this.showHideLoading();

          setTimeout(() => {
            window.scrollTo({
              top: document.getElementsByClassName('footer')[0].offsetTop - 500,
              behavior: 'smooth',
            });
          }, 100);
        })
        .catch((error) => {
          this.showHideLoading();
          this.rowData.show = true;
          SweetAlert.warning(error.response.data.message);
        });
    },

    searchedQueryDetails(searchedValue) {
      this.searchQueryDetails = searchedValue;
    },

    openMap() {
      this.modals.map = true;
      this.showHideLoading(true);

      // Esperamos un ciclo de render para que aparezca el <multiple-map>
      this.$nextTick(() => {
        const mapEl = this.$refs.map.$refs.multipleMap;
        this.loadSmartTrackMap(this.tableDataDetails, mapEl);

        try {
          document.getElementById('toolbarDiv').style = 'top: 16%;right: 18px;';
        } catch (e) {}
        this.showHideLoading(false);
      });
    },

    closeMap() {
      this.modals.map = false;
    },

    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        element.show = true;
      });
    },

    setupTable() {
      const { Table, TableDetails } = configTable();
      this.pagination = { ...Table.pagination };
      this.paginationDetails = { ...TableDetails.pagination };
      this.tableColumns = Table.tableColumns;
      this.tableColumnsDetails = TableDetails.tableColumns;
    },
  },
  created() {
    if (this.isIndex()) {
      this.setupTable();
      Axios.getMasters('works/workers/indexField').then((response_workers) => {
        this.workers = this.concatAll(response_workers.data.data);
        this.showHideLoading();
      });

      Axios.getMasters('works/activities/only/field').then(
        (response_activities) => {
          this.activities = this.concatAll(response_activities.data.data);
          this.showHideLoading();
        }
      );
    } else {
      this.showMessageAccess();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },
  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
